import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import style from './Label.module.scss';

interface Props {
  name?: string;
  textId: string;
}

class Label extends Component<Props> {
  render() {
    const { name, textId } = this.props;

    return (
      <label className={style.label} htmlFor={name}>
        <FormattedMessage id={textId} defaultMessage={name} />
      </label>
    );
  }
}

export { Label };
